import { useMutation } from "react-query";
import getNotelist from "../services/getNotelist";

function useNotelist() {
  return useMutation(["note-list"], getNotelist);
}

export default useNotelist;
